module.exports = __webpack_public_path__ + "img/qr-slide-1.87a81641.png";